import { FC } from 'react';
import classNames from 'classnames';

import { Slideout, SlideoutProps } from 'components/design-system/Slideout';

import { BuyersPremiumItem } from './BuyersPremiumItem';

export const BuyersPremiumSlideoutTestIds = {
  container: 'buyers-premium-slideout-container'
};

export type BuyersPremiumSlideoutProps = {
  buyersPremiumBips: number;
  buyersPremiumPromotionBips?: number | null;
} & SlideoutProps;

const otherAuctionHousesStats = [
  {
    name: "Bonham's",
    buyersPremiumPercentage: '28%'
  },
  {
    name: "Phillip's",
    buyersPremiumPercentage: '27%'
  },
  {
    name: "Christie's",
    buyersPremiumPercentage: '26%'
  },
  {
    name: "Sotheby's",
    buyersPremiumPercentage: '20%'
  }
];

export const BuyersPremiumSlideout: FC<BuyersPremiumSlideoutProps> = ({
  buyersPremiumBips,
  buyersPremiumPromotionBips,
  isDark,
  ...props
}) => (
  <Slideout
    data-testid={BuyersPremiumSlideoutTestIds.container}
    bodyClassName='riforma-regular'
    title="What's an auction fee?"
    isDark={isDark}
    {...props}
  >
    <div className='text-center mb-5 px-3'>
      <span className='text-secondary'>
        An auction fee is a standard fee charged to the winning bidder at auctions.{' '}
      </span>
      <span className={classNames({ 'text-light': isDark })}>
        Bezel&apos;s is the <span className='text-decoration-underline'>lowest on the market.</span>
      </span>
    </div>
    <p className='fs-12px letter-spacing-08 text-secondary text-center mb-3'>COMPARISONS</p>
    {otherAuctionHousesStats.map(stat => (
      <BuyersPremiumItem key={stat.name} isDark={isDark} {...stat} />
    ))}
    <BuyersPremiumItem
      isHighlighted
      isDark={isDark}
      name='Bezel'
      buyersPremiumPercentage={buyersPremiumBips / 100 + '%'}
      buyersPremiumPromotionPercentage={
        typeof buyersPremiumPromotionBips === 'number' ? buyersPremiumPromotionBips / 100 + '%' : undefined
      }
    />
    <div className='mb-4' />
  </Slideout>
);
